import { render, staticRenderFns } from "./cangchuSy.vue?vue&type=template&id=11bb9286&scoped=true&"
import script from "./cangchuSy.vue?vue&type=script&lang=js&"
export * from "./cangchuSy.vue?vue&type=script&lang=js&"
import style0 from "./cangchuSy.vue?vue&type=style&index=0&id=11bb9286&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bb9286",
  null
  
)

export default component.exports